module.exports = __webpack_public_path__ + "img/parker-westport-logo.2311fc26.webp";